import dashboard from './dashboard'
import myInvestor from '../../my-investor/_locale/en-US'
import agencyReport from '../../agency-report/_locale/en-US'
import transactionReports from '../../transaction-reports/_locale/en-US'
import commissionReport from '../../commission-report/_locale/en-US'
import commissionDetails from '../../commission-details/_locale/en-US'
import fundDetails from '../../fund-details/_locale/en-US'
import promotionMaterials from '../../promotion-materials/_locale/en-US'

export default {
  dashboard,
  myInvestor,
  agencyReport,
  transactionReports,
  commissionReport,
  commissionDetails,
  fundDetails,
  promotionMaterials,
}
